/**
 * @file 教程页页左侧菜单
 * @author FengGuang(fengguang01@baidu.com)
 */

import {ITutorialsGroupItem, ITutorialsLessonItem, ITutorialsProjectItem, ITutorialsVersionItem} from '../../../type';
import {ITutorialsGroupMap, ITutorialsLessonMap, ITutorialsProjectMap} from '../types';

const getSelectedObjects = (
    projectId: string,
    versionList: ITutorialsVersionItem[],
    groupMapByVersionId: ITutorialsGroupMap,
    lessonMapByGroupId: ITutorialsLessonMap,
    projectMapByLessonId: ITutorialsProjectMap
): [
    ITutorialsVersionItem | undefined,
    ITutorialsGroupItem | undefined,
    ITutorialsLessonItem | undefined,
    ITutorialsProjectItem | undefined
] => {
    let selectedVersion: ITutorialsVersionItem | undefined;
    let selectedGroup: ITutorialsGroupItem | undefined;
    let selectedLesson: ITutorialsLessonItem | undefined;
    let selectedProject: ITutorialsProjectItem | undefined;
    if (!projectId) {
        return [undefined, undefined, undefined, undefined];
    }
    versionList.some((version) => {
        return groupMapByVersionId[version.version]?.some((group) => {
            return lessonMapByGroupId[group.id]?.some((lesson) => {
                return projectMapByLessonId[lesson.id]?.some((project) => {
                    if (project.id === projectId) {
                        selectedVersion = version;
                        selectedGroup = group;
                        selectedLesson = lesson;
                        selectedProject = project;
                    }
                    return project.id === projectId;
                });
            });
        });
    });
    return [
        selectedVersion,
        selectedGroup,
        selectedLesson,
        selectedProject
    ];
};

export default getSelectedObjects;
